export const GET_HELP_ORDERS_REQUEST = '@helpOrders/GET_LIST_REQUEST';
export const GET_HELP_ORDERS_SUCCESS = '@helpOrders/GET_LIST_SUCCESS';
export const GET_HELP_ORDERS_FAILURE = '@helpOrders/GET_LIST_FAILURE';

export const POST_ANSWER_REQUEST = '@helpOrders/POST_ANSWER_REQUEST';
export const POST_ANSWER_SUCCESS = '@helpOrders/POST_ANSWER_SUCCESS';
export const POST_ANSWER_FAILURE = '@helpOrders/POST_ANSWER_FAILURE';
